const COLORS = ["bg-[var(--sun)]", "bg-[var(--mint)]", "bg-[var(--coral)]", "bg-sky-300", "bg-violet-300", "bg-lime-300"];

const Branch = ({ b, i, compact }) => (
  <div className="relative" data-testid={`concept-branch-${i}`}>
    <span className={`absolute top-1/2 h-[3px] bg-[var(--ink)] -left-6 w-6 ${i % 2 ? "sm:-left-8 sm:w-8" : "sm:left-auto sm:-right-8 sm:w-8"}`} />
    <div className={`ink-box-sm rounded-2xl ${COLORS[i % COLORS.length]} ${compact ? "p-2" : "p-4"}`}>
      {b.link && <p className="text-center text-[11px] font-extrabold italic text-neutral-700">{b.link}</p>}
      <p className={`font-display text-center font-bold ${compact ? "text-sm" : "text-lg"}`}>{b.label}</p>
      {b.children.length > 0 && (
        <ul className={`mt-2 space-y-1 ${compact ? "text-[11px]" : "text-sm"}`}>
          {b.children.map((c, j) => (
            <li key={j} className="rounded-lg border-2 border-[var(--ink)] bg-white px-2 py-1 font-semibold">{c}</li>
          ))}
        </ul>
      )}
    </div>
  </div>
);

export const ConceptMap = ({ map, compact = false }) => (
  <div className="flex flex-col items-start sm:items-center" data-testid="concept-map">
    <div className={`ink-box relative z-10 rounded-full bg-[var(--ink)] text-center text-white ${compact ? "px-5 py-2" : "px-8 py-4"}`}>
      <span className={`font-display font-bold ${compact ? "text-lg" : "text-2xl sm:text-3xl"}`} data-testid="concept-map-center">{map.center}</span>
    </div>
    <div className="relative w-full pt-6">
      <span className="absolute bottom-8 left-3 top-0 w-[3px] bg-[var(--ink)] sm:left-1/2 sm:-translate-x-1/2" />
      <div className="grid gap-y-5 pl-9 sm:grid-cols-2 sm:gap-x-16 sm:pl-0">
        {map.branches.map((b, i) => <Branch key={i} b={b} i={i} compact={compact} />)}
      </div>
    </div>
  </div>
);
